define('shared/initializer/form/adapters/mixins/LabelFloatable',['$', 'shared/lib/RSVP'], function($, RSVP) {
    'use strict';

    var CSSCLASS_FLOATING_LABEL = 'dynamic-label';
    var CSSCLASS_FLOATING_LABEL_INACTIVE = 'dynamic-label--inactive';
    var ATTRIB_PLACEHOLDER = 'placeholder';

    function setupLabel($el) {
        adjustPlaceholder($el);
        if ($el.is('input')) {
            $el.on('focus', function(){
                handleFocus($el);
            });
            
        }
        else if ($el.is('select')) {
            $el.on('change', function(){
                handleChange($el);
            });
        }

        $el.on('blur', function(){
            handleBlur($el);
        });
    }

    function handleFocus($el) {
        floatLabel($el);
    }

    function handleBlur($el) {
        adjustPlaceholder($el);
    }

    function handleChange($el) {
        adjustPlaceholder($el);
    }

    function floatLabel($input) {
        var $label = findLabel($input);
        $label.removeClass(CSSCLASS_FLOATING_LABEL_INACTIVE);
        if ($input.is('input')) {
            $input.attr(ATTRIB_PLACEHOLDER, '');    
        }
    }

    function adjustPlaceholder($input) {
        var $label = findLabel($input);
        if($input.val() === '' || $input.val() == null) { 
            $label.addClass(CSSCLASS_FLOATING_LABEL_INACTIVE);
            if ($input.is('input')) {
                $input.attr(ATTRIB_PLACEHOLDER, ($label.text() || '').trim());
            }
        } else {
            floatLabel($input);
        }
    }

    function findLabel($input) {
        return $input.siblings('label.' + CSSCLASS_FLOATING_LABEL);
    }

    function Ctor(){}

    Ctor.prototype.doPageLoad = function(){
        var me = this;
        return new RSVP.Promise(function( resolve ){
            me
                .$form
                .find('label.' + CSSCLASS_FLOATING_LABEL)
                .each(function (i, el) {
                    var $label = $(el);
                    var $control = $label.siblings('input, select');
                    setupLabel($control);
                });
            resolve();
        });
    };

    return Ctor;
});
